import * as React from "react";
import { TailwindBackgroundColors } from "../models/General";

export const ReservationButton: React.FC<{
  isLocked: boolean;
  transition?: React.CSSProperties;
  onClickHandler: () => any | Promise<any>;
  color: TailwindBackgroundColors;
  unlockedHeight?: boolean;
  noHeight?: boolean;
  additionalClasses?: string;
  children?: React.ReactNode | React.ReactNode[];
}> = React.memo(function ReservationButton({
  isLocked,
  transition,
  onClickHandler,
  children,
  color,
  unlockedHeight,
  noHeight,
  ...props
}) {
  const textSize = "text-sm md:text-base";
  return (
    <div
      className={`flex justify-between items-center ${
        noHeight ? "" : unlockedHeight ? "h-full" : "flex-grow-0 h-10 md:h-21"
      } w-full`}
    >
      {isLocked ? (
        <button
          type="button"
          disabled={isLocked}
          className={`flex flex-1 ring-1 ${
            unlockedHeight ? "h-full" : "h-10 md:h-12"
          } justify-center items-center ring-gray-400 bg-gray-300 text-gray-700 ${textSize} ${
            props.additionalClasses
          } ${transition ? "" : "transition-all duration-200 ease-in-out"}`}
          style={transition}
        >
          {children}
        </button>
      ) : (
        <button
          type="button"
          tabIndex={0}
          className={`flex flex-1 ${
            unlockedHeight ? "h-full" : "h-10 md:h-12"
          } justify-center items-center bg-${color}-500 text-white hover:bg-${color}-600 outline-none focus:outline-none focus:underline cursor-pointer hover:shadow ${textSize} ${
            props.additionalClasses
          } ${transition ? "" : "transition-all duration-200 ease-in-out"}`}
          style={transition}
          onClick={async () => {
            if (!isLocked) {
              await onClickHandler();
            }
          }}
          onKeyUp={async (ev) => {
            if (ev.key === "Enter") {
              if (!isLocked) {
                await onClickHandler();
              }
            }
          }}
        >
          {children}
        </button>
      )}
    </div>
  );
});
